import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'kierowcy/';

export default {

    getKierowcy() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getKierowcyAktywni() {
        return axios({
            method: 'get',
            url: URL + 'aktywni',
        });
    },

    getZajeciKierowcy(idKu) {
        return axios({
            method: 'get',
            url: URL + 'aktywni/'+idKu,
        });
    },

    getKierowcyPosiadajcyTelefon() {
        return axios({
            method: 'get',
            url: URL + 'kierowcyFcm/',
        });
    },

    addKierowca(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editKierowca(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteKierowca(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/kierowcy/KierowcyService.js